module.exports = function($) {

    function scrolling(params) {
        var args = $.extend({
            offset: 0,
            bodyclass: 'scrolling',
            clone: false
        }, params);

        var position = $(window).scrollTop();

        const f = {
            action: function () {
                let scroll = $(window).scrollTop();
                if (scroll > position) {
                    $('body').removeClass('scrollUp').addClass('scrollDown');
                } else {
                    $('body').addClass('scrollUp').removeClass('scrollDown');
                }
                position = scroll;
                //
                if ($(window).scrollTop() > args.offset) {
                    $('body').addClass(args.bodyclass);
                } else {
                    $('body').removeClass(args.bodyclass).removeClass('scrollUp');
                }
            }
        };

        $(window).on('scroll', function (e) {
            f.action();
        });
    }

    scrolling({
        offset: 0,
        bodyclass: 'scrolling'
    });

}
